/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createResource,
	type RouterDataContext,
	type RouterContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { FetchError, fetchJson } from '@atlassian/jira-fetch';

export const PROPERTY_KEY = 'csmGetStartedCustomerExperienceDisabled';

const getUrl = (projectKey: string | number, key: string) =>
	`/rest/api/3/project/${projectKey}/properties/${key}`;

export const getStartedPropertyResource: RouteResource<boolean> = createResource<boolean>({
	type: 'CUSTOMER_SERVICE_GET_STARTED_PROPERTY_RESOURCE',
	getKey: ({ match }: RouterContext) =>
		`customer-service-get-started-property-${match.params.projectKey}`,
	getData: async ({ match }: RouterDataContext) => {
		try {
			return await fetchJson<boolean>(getUrl(match.params.projectKey || '', PROPERTY_KEY));
		} catch (error) {
			if (error instanceof FetchError && error.statusCode === 404) {
				return false;
			}
			throw error;
		}
	},
	maxAge: 1000 * 60 * 60 * 24, // 24 hours
});
